"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = __importDefault(require("../state"));
const getPausedTime_1 = __importDefault(require("./getPausedTime"));
const levelIsCompleted_1 = __importDefault(require("./levelIsCompleted"));
const isCatStarving = () => (0, levelIsCompleted_1.default)() === false && state_1.default.hasLevelStartedAt() && state_1.default.hasLevelStartedAt() && state_1.default.currentTime - state_1.default.levelStartedAt - (0, getPausedTime_1.default)() >= state_1.default.level.time;
exports.default = isCatStarving;
